import http from "@/utils/http";
import qs from "qs";

export function getUserInfo(callback) {
  http
    .get("/api/users/me/")
    .then(function (response) {
      // 处理成功情况
      console.log(response);
      callback(null, response);
    })
    .catch(function (error) {
      // 处理错误情况
      console.log(error);
      callback(error, null);
    })
    .finally(function () {
      // 总是会执行
      // alert('执行吧')
    });
}

export function getCharacterInfo(characterId, callback) {
  http
    .get("/api/character/get_character_detail_info", {
      params: {
        character_id: characterId,
      },
    })
    .then(function (response) {
      // 处理成功情况
      console.log(response);
      callback(null, response);
    })
    .catch(function (error) {
      // 处理错误情况
      console.log(error);
      callback(error, null);
    })
    .finally(function () {
      // 总是会执行
      // alert('执行吧')
    });
}

export function getDownloadUrl(params) {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/invitation/get_download_url?${qs.stringify(params)}`)
      .then((res) => {
        resolve(res.payload.download_url);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
